import React, { Component } from 'react';
import MapHeader from '../MapHeader/MapHeader';
import Map from '../Map/Map';
import MobileHeader from '../MobileHeader/MobileHeader';

export default class App extends Component {
  constructor() {
    super();
    this.state = {
      currentFilter: "אומנות"
    }
  }
  setFilter = filter => this.setState({
    currentFilter: filter
  })
  render() {
    return (
      <div className="App">
        {/* <MobileHeader /> */}
        <MapHeader currentFilter={this.state.currentFilter} setFilter={this.setFilter} />
        <Map currentFilter={this.state.currentFilter} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/App/App.jsx